(function($){
    'use strict';
    window.w4d = window.w4d || {};
  
    w4d.photoCollage2 = {
      init: function() {
        var galleries = document.querySelectorAll('[id^="w4d-photo-collage-2-gallery-"]');
        if (!galleries.length) return;
  
        galleries.forEach(function(gallery) {
          lightGallery(gallery, {
            selector: '.photo-collage-2__item',
            plugins: [ lgZoom, lgThumbnail ],
            thumbnail: true,
            animateThumb: true,
            showThumbByDefault: false,
            exThumbImage: 'data-exthumbimage',
            speed: 500,
            download: false,
          });
        });
      }
    };
  
    $(document).ready(function(){
      w4d.photoCollage2.init();
    });
  })(jQuery);
  